<template>
  <div class="count-box">
    <button class="minus" @click="subFn">-</button>
    <input class="inp" type="text" :value="value" @change="handleChange">
    <button class="add" @click="addFn">+</button>
  </div>
</template>

<script>
export default {
  name: 'CountBox',
  props: {
    // 商品数量
    value: {
      type: Number,
      default: 1
    }
  },
  methods: {
    // 减
    subFn () {
      if (this.value <= 1) return
      this.$emit('input', this.value - 1)
    },
    // 加
    addFn () {
      this.$emit('input', this.value + 1)
    },
    // 手动输入
    handleChange (e) {
      const value = Number(e.target.value)
      if (value < 1 || isNaN(value)) {
        this.$emit('input', 1)
        return
      }
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="less" scoped>
.count-box {
  width: 110px;
  display: flex;

  .add,
  .minus {
    width: 30px;
    height: 30px;
    outline: none;
    border: none;
    background-color: #efefef;
  }

  .inp {
    width: 40px;
    height: 30px;
    outline: none;
    border: none;
    margin: 0 5px;
    background-color: #efefef;
    text-align: center;
  }
}
</style>
